__turbopack_context__.v({
  "cardsContainer": "serviceCards-module-scss-module__w-kFRq__cardsContainer",
  "serviceCards": "serviceCards-module-scss-module__w-kFRq__serviceCards",
  "text": "serviceCards-module-scss-module__w-kFRq__text",
  "title": "serviceCards-module-scss-module__w-kFRq__title",
});
